import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  foilCutterSchema,
  FoilCutterFormValues,
} from "../validation/yup/foilCutterSchema";

export const useFoilCutterForm = () =>
  useForm<FoilCutterFormValues>({
    defaultValues: {
      foilType: "",
      foilBatch: "",
      foilExpirationDate: undefined,
      isFoilSampleStored: false,
      other: false,
      otherText: undefined,
    },
    resolver: yupResolver(foilCutterSchema),
    mode: "onSubmit",
    reValidateMode: "onBlur",
  });
